<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "border rounded mt-2 p-1" }, [
      _c("div", { staticClass: "dispute d-inline-block mr-2" }, [
        _vm._v(_vm._s(_vm.$t("dispute.Dispute"))),
      ]),
      _c(
        "div",
        { staticClass: "dispute-text mt-2" },
        [
          _vm._v(" " + _vm._s(_vm.$t("dispute.Dispute-brief")) + " "),
          _c("b-link", [_vm._v(_vm._s(_vm.remainingTime))]),
        ],
        1
      ),
      _c("ol", { staticClass: "ol-text mt-1" }, [
        !_vm.isCounterParty
          ? _c("li", [
              _vm._v(" " + _vm._s(_vm.$t("dispute.Dstatement1")) + " "),
            ])
          : _vm._e(),
        _c("li", [_vm._v(" " + _vm._s(_vm.$t("dispute.Dstatement2")) + " ")]),
        _c("li", [_vm._v(" " + _vm._s(_vm.$t("dispute.Dstatement3")) + " ")]),
      ]),
      _c(
        "div",
        [
          !_vm.isCounterParty
            ? _c(
                "b-button",
                {
                  attrs: { variant: "primary  mr-2 min-120-btn" },
                  on: {
                    click: function ($event) {
                      return _vm.updateDispute("CANCELLED")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Dispute-Status.dispute-Status")))]
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/@core/components/dispute/Dispute.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default ({
  render,
  staticRenderFns,
  components: {
    BButton: bootstrapvue["BButton"],
    BLink: bootstrapvue["BLink"]
  },
  props: {
    remainingTime: {
      type: String,
      default: ""
    },
    isCounterParty: {
      type: Boolean,
      default: true
    },
    updateDispute: {
      type: Function,
      default: () => {}
    }
  }
});

//# sourceURL=webpack:///./src/@core/components/dispute/Dispute.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style>
.dispute {
  color: var(--text-black-color);
  font-size: 19px;
  font-weight: 600;
  line-height: 24px;
}
.dispute-text {
  color: var(--text-black-color);
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
}
.ol-text {
  color: var(--text-black-color);
  font-size: 13px;
  font-weight: 400;
  line-height: 24px;
}
</style>
